<template>
  <div class="mb-4">
    <h1 class="display-4">{{ title }}</h1>
    <h4 class="text-muted">{{ subtitle }}</h4>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BackBtn',
  props: {
    title: String,
    subtitle: String,
  },
});
</script>
<style scoped></style>
